import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, TextField, Select, MenuItem, Box, Typography, FormControl, InputLabel, Grid, InputAdornment, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';

import Inventory from "../../models/inventory";
import Inventories from "../../collections/inventories";

const InventoryLevelTransactions = (props) => {
  const [inventories, setInventories] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [transactionType, setTransactionType] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    props.setPageTitle("Danh sách nhập hàng");

    const fetchInventoriesWithDate = async () => {
      const ApiPage = page + 1;
      const listInventories = new Inventories();
      const start_date = dayjs(dateRange[0]).isValid() ? dayjs(dateRange[0]).format("YYYY-MM-DD") : null;
      const end_date = dayjs(dateRange[1]).isValid() ? dayjs(dateRange[1]).format("YYYY-MM-DD") : null;
      await listInventories.fetchWithDate(ApiPage, rowsPerPage, start_date, end_date, transactionType);
      setInventories(listInventories.items);
      setTotalTransactions(listInventories.total);
    }
    fetchInventoriesWithDate();
  }, [page, rowsPerPage, dateRange, transactionType])
  console.log(transactionType);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleDateChange = (index, newValue) => {
    const newDateRange = [...dateRange];
    newDateRange[index] = newValue;
    setDateRange(newDateRange);
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
    setPage(0);
  };

  return (
    <Container sx={{ mt: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '16px' }}>
        <TextField
          label="Tìm kiếm đơn nhập hàng"
          sx={{ width: '350px' }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton

                >
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Lọc kết quả:
      </Typography>
      <Grid container spacing={4} sx={{ mb: 2 }}>
        <Grid item xs={4}>
          <DatePicker
            label="Từ ngày"
            value={dateRange[0]}
            onChange={(newValue) => {
              handleDateChange(0, newValue);
              setPage(0);
            }}
            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '100%' }}
          />
        </Grid>
        <Grid item xs={4}>
          <DatePicker
            label="Đến ngày"
            value={dateRange[1]}
            onChange={(newValue) => {
              handleDateChange(1, newValue);
              setPage(0);
            }}
            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} />}
            inputFormat="DD/MM/YYYY"
            sx={{ width: '100%' }}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControl sx={{ width: '100%' }}>
            <InputLabel id="transaction-type-label">Loại giao dịch</InputLabel>
            <Select
              labelId="transaction-type-label"
              value={transactionType}
              onChange={handleTransactionTypeChange}
              label="Loại giao dịch"
            >
              <MenuItem value="">Tất cả</MenuItem>
              <MenuItem value="addition">Nhập hàng</MenuItem>
              <MenuItem value="order">Tạo đơn hàng</MenuItem>
              <MenuItem value="order_update">Cập nhật đơn hàng</MenuItem>
              <MenuItem value="po_return">Trả hàng NCC</MenuItem>
            </Select >
          </FormControl >
        </Grid >
      </Grid >
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Tên sản phẩm</TableCell>
              <TableCell>Số lượng</TableCell>
              <TableCell>Loại giao dịch</TableCell>
              <TableCell>Mô tả</TableCell>
              <TableCell>Ngày giao dịch</TableCell>
              <TableCell>Ngày tạo</TableCell>
              <TableCell>Ngày cập nhật</TableCell>
              <TableCell>Người tạo</TableCell>
              <TableCell>Hành động</TableCell>
            </TableRow >
          </TableHead >
          <TableBody>
            {inventories.map((item) => (
              <TableRow key={item.id}>
                <TableCell>{item.id}</TableCell>
                <TableCell>{item.product?.name || "N/A"}</TableCell>
                <TableCell>{item.quantity.toFixed(2) || 0}</TableCell>
                <TableCell>
                  {item.transaction_type === 'addition' && 'Nhập hàng'}
                  {item.transaction_type === 'order' && 'Tạo đơn hàng'}
                  {item.transaction_type === 'order_update' && 'Cập nhật đơn hàng'}
                  {item.transaction_type === 'po_return' && 'Trả hàng NCC'}
                </TableCell>
                <TableCell>{item.description || "Không có mô tả"}</TableCell>
                <TableCell>
                  {new Date(item.happened_at).toLocaleString("vi-VN")}
                </TableCell>
                <TableCell>
                  {new Date(item.created_at).toLocaleString("vi-VN")}
                </TableCell>
                <TableCell>
                  {new Date(item.updated_at).toLocaleString("vi-VN")}
                </TableCell>
                <TableCell>
                  {item.created_by?.name || "-"}
                </TableCell>
                <TableCell>
                  <Button
                    variant="outlined"
                    onClick={() => navigate(`/inventory_level_transactions/${item.id}`)}
                    sx={{ textTransform: 'none' }}
                  >
                    Chỉnh sửa
                  </Button>
                </TableCell>
              </TableRow >
            ))}
          </TableBody >
        </Table >
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={totalTransactions}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Số hàng mỗi trang"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} của ${count}`}
        />
      </TableContainer >
    </Container >
  );
}

export default InventoryLevelTransactions;
